import React from "react";
import io from "socket.io-client";
// https://aitutors.org/
// let url = `https://3.77.196.114:4000`
let url="https://bayin.app:4000"
export const socket = io.connect(url,{
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    randomizationFactor: 0.5,
    // secure: true
  });
export const SocketContext = React.createContext();